<template>
  <div class="pa-3">
    <v-alert
      v-if="company.remainingLimit && company.remainingLimit.amount < 1"
      type="info"
      dense
      color="danger"
      class="my-2">
      The current company has no remaining balance.
    </v-alert>
    <v-row align="start">
      <v-col cols="12" lg="6" class="d-flex flex-column justify-space-between">
        <div>
          <h4 class="mt-2 ml-1 primary--text">Company Information</h4>
          <v-card class="d-flex my-1 pa-3 borderccc">
            <v-row class="pt-1 ma-0">
              <v-col cols="6" class="d-flex flex-column justify-space-between pa-0 ma-0">
                <div>
                  <span class="info-title">Company Name</span>
                  <span class="info-text">{{ company.name ? company.name : "---" }}</span>
                </div>
                <div class="my-1">
                  <span class="info-title">Category</span>
                  <span class="info-text text-capitalize">{{ company.category ? company.category : "---" }}</span>
                </div>
                <div>
                  <span class="info-title">Organization Number</span>
                  <span class="info-text">{{ company.organizationNumber ? company.organizationNumber : "---" }}</span>
                </div>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0">
                <span class="info-title">Tenants</span>
                <div style="width: 100%">
                  <span v-for="(tenant, idx) in filteredTenantNames" :key="idx" class="info-text d-inline-block">
                    {{ company.tenants ? tenant : "---"
                    }}<span v-if="idx < filteredTenantNames.length - 1">,&nbsp;</span>
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>

        <div>
          <h4 class="mt-2 ml-1 primary--text">Contact Person</h4>
          <v-card class="my-1 pa-3 borderccc">
            <v-row class="pt-1 ma-0">
              <v-col cols="12" md="8" class="pa-0 ma-0">
                <span class="info-title">Full Name</span>
                <span class="info-text">{{ company.contactPersonName ? company.contactPersonName : "---" }}</span>
              </v-col>
              <v-col cols="12" md="4" class="pa-0 ma-0">
                <span class="info-title">Phone Number</span>
                <span class="info-text">{{ company.phone ? company.phone : "---" }}</span>
              </v-col>
            </v-row>
            <v-row class="pt-1 ma-0">
              <v-col class="pa-0 ma-0">
                <span class="info-title">E-Mail</span>
                <span class="info-text">{{ company.email ? company.email : "---" }}</span>
              </v-col>
            </v-row>
          </v-card>
        </div>

        <div>
          <h4 class="mt-2 ml-1 primary--text">Default Codes</h4>
          <v-card class="my-1 pa-3 borderccc">
            <v-row class="pt-1 ma-0">
              <v-col cols="12" class="pa-0 ma-0">
                <span class="info-title">Campaign Codes</span>

                <div v-if="company.defaultCampaignCodes && company.defaultCampaignCodes.length" class="mt-1">
                  <div v-for="(item, index) in company.defaultCampaignCodes" :key="index" class="mb-2">
                    <v-chip label small class="agreement-chip" outlined>
                      <span class="chip-key">Code:</span><span class="chip-val">{{ item.code }}</span>
                      <span class="mx-2"></span>
                      <span class="chip-key">Title:</span><span class="chip-val">{{ item.title || "-" }}</span>
                      <span class="mx-2"></span>
                      <span class="chip-key">Hidden:</span>
                      <v-chip
                        x-small
                        :color="item.hidden ? 'green lighten-1' : 'grey lighten-2'"
                        :class="item.hidden ? 'chip-bool-yes' : 'chip-bool-no'"
                        class="field-status-chip">
                        {{ item.hidden ? "YES" : "NO" }}
                      </v-chip>
                      <span class="mx-2"></span>
                      <span class="chip-key">Apply by default:</span>
                      <v-chip
                        x-small
                        :color="item.applyByDefault ? 'green lighten-1' : 'grey lighten-2'"
                        :class="item.applyByDefault ? 'chip-bool-yes' : 'chip-bool-no'"
                        class="field-status-chip">
                        {{ item.applyByDefault ? "YES" : "NO" }}
                      </v-chip>
                    </v-chip>
                  </div>
                </div>

                <div v-else class="info-text mt-1 ml-2">---</div>
              </v-col>
            </v-row>

            <v-row class="pt-1 ma-0">
              <v-col cols="12" class="pa-0 ma-0">
                <span class="info-title">Agreement Codes</span>

                <div
                  v-if="company.defaultAgreementCodes && company.defaultAgreementCodes.length"
                  class="agreement-chip-wrap mt-2">
                  <v-chip
                    v-for="(item, index) in company.defaultAgreementCodes"
                    :key="index"
                    class="agreement-chip mb-2 mr-2"
                    small
                    outlined
                    label>
                    <span class="chip-key">Code:</span><span class="chip-val">{{ item.code }}</span>
                    <span class="mx-2"></span>
                    <span class="chip-key">Carrier:</span
                    ><span class="chip-val">{{ getCarrierText(item.issuer) }}</span>
                  </v-chip>
                </div>

                <div v-else class="info-text mt-1 ml-2">---</div>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-col>

      <v-col cols="12" lg="6" class="d-flex flex-column justify-space-between">
        <div>
          <h4 class="mt-2 ml-1 primary--text">Reference</h4>
          <v-card class="my-1 pa-3 borderccc">
            <v-row class="pt-1 ma-0">
              <v-col cols="12" md="7" class="pa-0 ma-0">
                <span class="info-title">E-Mail for Invoice or E-Invoice</span>
                <span class="info-text">{{ company.invoiceEmail ? company.invoiceEmail : "---" }}</span>
              </v-col>
              <v-col cols="12" md="5" class="pa-0 ma-0">
                <span class="info-title">Fortnox Customer ID</span>
                <span class="info-text">{{ company.fortnoxCustomerId ? company.fortnoxCustomerId : "---" }}</span>
              </v-col>
            </v-row>
            <v-row class="pt-1 ma-0">
              <v-col cols="12" md="7" class="pa-0 ma-0">
                <span class="info-title">Other / Branch</span>
                <span class="info-text">{{ company.reference ? company.reference : "---" }}</span>
              </v-col>
            </v-row>
          </v-card>
        </div>

        <div>
          <h4 class="mt-2 ml-1 primary--text">Finance</h4>
          <v-card class="my-1 pa-3 borderccc">
            <v-row class="pt-1 ma-0" cols="12" md="7">
              <v-col class="pa-0 ma-0">
                <span class="info-title">Allowed Days to Pay the Invoice</span>
                <span class="info-text">{{ company.allowedDaysToPay ? company.allowedDaysToPay : "---" }}</span>
              </v-col>
              <v-col class="pa-0 ma-0" cols="12" md="5">
                <span class="info-title">Limit</span>
                <span class="info-text">{{ company.limit.amount ? company.limit.plainText : "---" }}</span>
              </v-col>
            </v-row>
            <v-row class="pt-1 ma-0">
              <v-col class="pa-0 ma-0" cols="12" md="7">
                <span class="info-title">Automatically Add Invoice Fee</span>
                <span class="info-text">{{ company.automaticInvoiceFeeEnabled ? "YES" : "NO" }}</span>
              </v-col>

              <v-col class="pa-0 ma-0" cols="12" md="5">
                <span
                  class="info-title"
                  :class="
                    company.remainingLimit && company.remainingLimit.amount != 0 ? 'greeny--text' : 'primary--text'
                  "
                  >Remaning Limit</span
                >
                <span class="info-text">{{
                  company.remainingLimit && company.remainingLimit.amount ? company.remainingLimit.plainText : "---"
                }}</span>
              </v-col>
            </v-row>
            <v-row class="pt-1 ma-0">
              <v-col class="pa-0 ma-0" cols="12" md="7">
                <span class="info-title">Allow Debiting by Invoice</span>
                <span class="info-text">{{ company.trusted ? "YES" : "NO" }}</span>
              </v-col>
            </v-row>
          </v-card>
        </div>

        <div>
          <h4 class="mt-2 ml-1 primary--text">Auto-Invoicing Through Fortnox</h4>
          <v-card class="my-1 pa-3 borderccc">
            <v-row class="pt-1 ma-0">
              <v-col class="pa-0 ma-0" cols="12" md="7">
                <span class="info-title">Auto-Invoicing Frequency</span>
                <span class="info-text">
                  {{ getInvoicingFrequencyText(company.invoicingFrequency) }}
                </span>
              </v-col>
              <v-col class="pa-0 ma-0" cols="12" md="5">
                <span class="info-title">Auto-Invoicing Method</span>
                <span class="info-text">
                  {{ getInvoicingMethodText(company.invoicingMethod) }}
                </span>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-card v-if="company && company.comment" class="my-2 borderccc py-3" style="background-color: #fff6d9">
      <v-row>
        <v-col>
          <v-card-title class="black--text mt-0 pt-0"
            ><span class="text-sm-body-2 font-weight-bold">Internal Message</span></v-card-title
          >
          <v-card-subtitle class="black--text mb-0 pb-0"> {{ company.comment }}</v-card-subtitle>
        </v-col>
      </v-row>
    </v-card>

    <h4 class="mt-6 ml-1 primary--text">Authorized Employees</h4>

    <div class="text-center">
      <v-progress-circular :size="50" color="primary" class="mt-2" v-if="loading" indeterminate></v-progress-circular>
    </div>
    <div v-if="!loading" style="padding: 2px">
      <v-card
        v-for="(item, index) in company.customers"
        :key="index"
        class="my-5 px-3 py-5 borderccc d-flex align-start customer-card"
        :class="{
          'employee-manager': item.companyRole === 'employee_manager',
        }">
        <div v-if="item.companyRole === 'employee_manager'" class="employee-manager-badge">
          <v-tooltip bottom max-width="280">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-icon dense aria-hidden="false" color="white">mdi-badge-account</v-icon>
                <span class="ml-2 font-weight-bold">{{ getCompanyRoleText(item.companyRole) }}</span>
              </span>
            </template>
            <span>
              Allows adding, updating, and removing this company's authorized employees using the selected account.
            </span>
          </v-tooltip>
        </div>
        <v-row class="employee-row">
          <v-col cols="12" md="3">
            <v-icon dense aria-hidden="false" color="accent"> mdi-pound </v-icon>
            <span class="accent--text font-weight-bold">IATA Number</span>
            <span v-if="item.companyCustomerNumber" class="ml-2 font-weight-bold">
              {{ item.companyCustomerNumber }}
            </span>
            <span v-else class="ml-2 font-weight-bold">----</span>
          </v-col>

          <v-col cols="12" md="3">
            <v-icon dense aria-hidden="false" color="accent"> mdi-account </v-icon>
            <span v-if="item.firstName || item.lastName" class="font-weight-bold">
              {{ item.firstName + " " + item.lastName }}
            </span>
            <span v-else class="ml-2 font-weight-bold">----</span>
          </v-col>

          <v-col cols="12" md="4">
            <v-icon dense aria-hidden="false" color="accent"> mdi-email </v-icon>
            <span v-if="item.email" class="ml-2 font-weight-bold">{{ item.email }}</span>
            <span v-else class="ml-2 font-weight-bold">----</span>
          </v-col>

          <v-col cols="12" md="2">
            <v-icon dense aria-hidden="false" color="accent"> mdi-phone </v-icon>
            <span v-if="item.phone" class="ml-2 font-weight-bold">{{ item.phone }}</span>
            <span v-else class="ml-2 font-weight-bold">----</span>
          </v-col>
        </v-row>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" dense aria-hidden="false" color="accent">mdi-information-outline</v-icon>
          </template>
          <span v-if="item.reference">Reference: {{ item.reference }}</span>
          <span v-else>No reference provided</span>
        </v-tooltip>
      </v-card>
    </div>
    <h4 class="black--text mt-6 mb-2" style="margin-left: 4px">
      <span class="mango-red">Activity log </span>({{ company.events.length }})
    </h4>
    <v-row justify="space-between">
      <v-col cols="12" lg="12">
        <v-card style="margin-left: 2px; margin-right: 2px">
          <v-card-text class="elevation-1">
            <v-timeline dense align-top>
              <event-list :events="company.events" />
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EventList from "@/views/Orders/components/EventList.vue";
import { mapGetters } from "vuex";
import carrierList from "@/assets/carriers.json";

export default {
  components: { EventList },
  props: {
    company: [],
    loading: Boolean,
  },
  computed: {
    ...mapGetters({
      tenants: "auth/userTenants",
    }),
    filteredTenantNames() {
      return this.getTenantNames(this.company.tenants);
    },
  },
  methods: {
    getTenantNames(tenantIds) {
      return this.tenants.filter((tenant) => tenantIds.includes(tenant.id)).map((tenant) => tenant.name);
    },
    getInvoicingFrequencyText(frequency) {
      const frequencyMap = {
        never: "Never",
        minutely: "Minutely",
        hourly: "Hourly",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
      };

      return frequencyMap[frequency] || "---";
    },
    getInvoicingMethodText(method) {
      const methodMap = {
        individually: "Per-order invoicing",
        in_bulk: "Bulk invoicing",
      };

      return methodMap[method] || "---";
    },
    getCarrierText(value) {
      if (value == null) return "---";

      const numericValue =
        typeof value === "string" && value.startsWith("urn:x_swe:carrier:")
          ? parseInt(value.split(":").pop(), 10)
          : parseInt(value, 10);

      const carrier = carrierList.find((c) => c.value === numericValue);
      return carrier ? carrier.text : value;
    },
    getCompanyRoleText(role) {
      const roles = { employee_manager: "Employee Manager" };
      return roles[role] || "---";
    },
  },
};
</script>

<style lang="scss" scoped>
.info-title {
  font-weight: bold;
  color: #5e87c1;
  font-size: 14px;
  display: block;
}

.info-text {
  color: #444;
  font-weight: 500;
  display: block;
  font-size: 15px;
}

.agreement-row-sm {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  background: #f4f6f8;
  border: 1px solid #d7dde3;
}

.agreement-row-sm .agreement-code {
  font-size: 12px;
  font-weight: 600;
  color: #384247;
  letter-spacing: 0.2px;
}

.agreement-row-sm .agreement-carrier {
  font-size: 11px;
  color: #6b7a86;
}

.chip-key {
  color: #888;
  font-size: 11px;
  font-weight: 500;
  margin-right: 3px;
  letter-spacing: 0.2px;
}

.chip-val {
  font-weight: 700;
  color: #424242;
  margin-left: 2px;
}

.field-status-chip {
  font-size: 9px !important;
  font-weight: 700 !important;
  height: 16px !important;
  padding: 0 6px !important;
  letter-spacing: 0.5px !important;
}

.chip-bool-yes {
  color: #fff !important;
}

.chip-bool-no {
  color: #555 !important;
}

.customer-card {
  gap: 10px;
  position: relative;
}

.employee-manager {
  border: 2px solid #507dbc !important;
}

.employee-manager-badge {
  position: absolute;
  top: -14px;
  right: 24px;
  padding: 4px 14px;
  border-radius: 8px;
  background-color: #507dbc;
  font-size: 14px;
  color: white;
}
</style>
